module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "ct2",
    attrs: {
      "id": "pz11-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#con1",
      "id": "toc1"
    }
  }, [_c('i', [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1a",
    attrs: {
      "id": "pz11-4"
    }
  }, [_c('i', [_vm._v("Friday, October 29, 2004")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1a",
    attrs: {
      "id": "pz11-5"
    }
  }, [_c('i', [_vm._v("The Day")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pz11-6"
    }
  }, [_vm._v("A "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MAGIC MOVES THE DAY AS IF ANYTHING COULD HAPPEN")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERHAPS")]), _vm._v(" it’s the pulse of jazz in the air, or the rhythmic churn of the riverboats, or the warm winds that swoop the levee, but there’s a hint of mystery surrounding us. Something has charged the marrow walled within my bones. "), _c('i', [_vm._v("Pay attention")]), _vm._v(", it says. And so I do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz11-7"
    }
  }, [_vm._v("It’s the week of Halloween—not the best time to bring a sixth-grade class on a field trip to the Big Easy. But three rain delays pushed back the date, so here we are in New Orleans, where thick, milky fog rises from the river like steam. It nearly blocks our view of a shiny white tugboat and her long string of barges nosing their way through the coffee-colored currents.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz11-8"
    }
  }, [_vm._v("We wait at Mardi Gras World, the famous tourist trap where my daughter, Ellie, and her classmates have come to learn the history of carnival season. Unlike the cars that buzz across the Crescent City Connection, or the boats that linger lazily beneath the bridge, we are landbound. We’re also surrounded by mermaids, each elaborately carved and painted by Blaine Kern’s studio artists.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz11-9"
    }
  }, [_vm._v("Around the sculptures, a festive crowd filters through. They are free spirits, wearing rainbow face paint as they scuttle for a better view of the Mississippi. “A cape?” my friend Beth whispers. “Cute.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz12-5"
    }
  }, [_vm._v("“Getting that party started early.” Raelynn eyes the most flamboyant tourist before taking a seat beneath the pergola. “Argh, it’s wet.” She pulls beads around her neck, adjusting the plastic pendant that serves as our admission ticket for the guided tour.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz12-6"
    }
  }, [_vm._v("Across the waterfront patio, a brass band pipes through scratchy speakers. Potted palm trees dance in the breeze. From the river, a dull horn bellows, causing our students to roar. The raucous tourist swings by again, her cape whipping wildly, her cheeks all aglitter. While this scene might be expected during Mardi Gras, it’s unusual for a Friday morning in October.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz12-7"
    }
  }, [_vm._v("My daughter shuffles through the crowd, staying close to her best friend, Sarah. A heavyweight redhead wearing dollar-store fangs jumps in front of them with a deep and masculine “Boo!” Ellie startles, and the jokester jolts away, laughing. This leaves our students wide-eyed, the chaperones on edge.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz12-8"
    }
  }, [_vm._v("“Let’s go ahead and get the children back inside,” Miss Henderson instructs. She is young and not yet burned out from the never-ending demands of public education. Even now she remains pleasant as she taps one of her more rambunctious students on the shoulder, nudging him down from the railing where he’s at risk of falling into the dangerous currents.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz12-9"
    }
  }, [_vm._v("“Girls?” Beth and I both call for our daughters. In response, Sarah and Ellie skip into line, their arms laced together, their steps in sync. As they prance beneath a strand of purple and green party lights, Sarah’s blond hair catches a glow, exaggerating her angelic complexion. Her innocent blue eyes twinkle with a sort of naïve joy not normally associated with raucous Bourbon Street celebrations. I whisper to Beth, “She could model for American Girl dolls.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz12-10"
    }
  }, [_vm._v("“They’re both beautiful.” Raelynn drags behind. “The only problem is, which one will get to marry my Nate?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-5"
    }
  }, [_vm._v("“Yuck!” they protest, and Miss Henderson laughs, closing the double doors behind us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-6"
    }
  }, [_vm._v("Inside the gift shop, students explore rows of spirit dolls and voodoo pins, while Sarah and Ellie move to the collection of intricate masks. They have just begun to dance in disguise when a shopper steps up from behind. She’s older than us. Close to fifty, I’m guessing. At thirty-five, fifty is sounding younger to me by the day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-7"
    }
  }, [_vm._v("“They sisters?” She asks this while watching Ellie and Sarah giggle in feathered face gear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-8"
    }
  }, [_vm._v("“Might as well be,” Beth answers. “Born on the same day. Best friends since birth.” She doesn’t bother explaining that our girls are without siblings and have learned to rely on one another to fill that role.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-9"
    }
  }, [_vm._v("“Figures. My daughters wouldn’t have been so nice to each other at that age.” She looks at me a little too long, and I shift away, adjusting my heavy backpack. It’s crammed with first-aid gear and water bottles—just in case.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-10"
    }
  }, [_vm._v("The woman leans closer. “You’re from Walker?” She points to my bright-green shirt, the one Miss Henderson designed. It shows a school bus surrounded by classic New Orleans symbols: Mardi Gras masks, musical notes, and the traditional fleur-de-lis. At the bottom it reads "), _c('i', [_vm._v("LP to NOLA 2004")]), _vm._v(", suggesting we’ve all traveled more than an hour east from rural Livingston Parish to explore our state’s most famous city, “The City That Care Forgot.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-11"
    }
  }, [_vm._v("I nod. “We’re here for a field trip. You?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-12"
    }
  }, [_vm._v("“Albany,” she says. “You may not remember, but are you a social worker? In Denham Springs? Amanda Salassi?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-14"
    }
  }, [_vm._v("My heart sinks. "), _c('i', [_vm._v("Is she one of my clients? Why can’t I place her?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-15"
    }
  }, [_vm._v("I scrape my brain, trying to pull this file—her round face, the "), _c('span', {
    attrs: {
      "id": "z14-5"
    }
  }, [_vm._v("gnawed fingernails, the tiny Hungarian hamlet of Albany known for its strawberries and quiet way of life. I draw nothing but blanks. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-6"
    }
  }, [_vm._v("“You go out on call sometimes, with Sheriff Ardoin?” She keeps her voice low, hesitant.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-7"
    }
  }, [_vm._v("Chills rise. I remember. She weighed at least a hundred pounds less when I last saw her, but her soft voice, something about that thin smile. “Mrs. Hosh?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-8"
    }
  }, [_vm._v("She nods, and we offer one another a warm glance"), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-9"
    }
  }, [_vm._v("“I’m sorry I didn’t recognize you. Your hair was a lot longer. And brown.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-10"
    }
  }, [_vm._v("“Yeah.” She says this with a half chuckle, reaching up to feel her short blond crop.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-11"
    }
  }, [_vm._v("It’s all coming back to me now. The tight-knit settlement. The protective way her kinfolk circled, unwilling to let me in. Her late-night calls to my home phone, in secret, asking to talk.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-12"
    }
  }, [_vm._v("“I want you to know”—she dabs her eye with the back of her finger—“I couldn’t have survived it without you. Knowing you cared. And you didn’t judge. Getting the others to call me. That helped. More than you can understand. Just knowing they had survived it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-13"
    }
  }, [_vm._v("I gesture for Beth to watch the girls. Then I lead Mrs. Hosh to the side. “You’re here,” I whisper. “You survived it too.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-15"
    }
  }, [_vm._v("“One breath at a time. That’s all I can do.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-16"
    }
  }, [_vm._v("“That’s all you have to do,” I tell her, drawing her into a gentle hug. “Just keep breathing.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-17"
    }
  }, [_vm._v("She holds me close, so tight her shoulder clamps against my throat, but I don’t dare pull away. It doesn’t matter that we are in a public gift shop, surrounded by chaperones and strangers. Or that my daughter and her friends watch us as they toy with touristy trinkets. All that matters is that this woman, right this moment, needs a hug. So that’s what we do. We hug.")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "pAS0"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images/img-15-1.jpg",
      "id": "AS0",
      "src": "images/img-15-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pz15-5"
    }
  }, [_vm._v("After the emotional exchange with Mrs. Hosh, I hurry to catch up with Ellie’s class. They are following a cheerful tour guide into the theater, where he instructs us to zip sparkly costumes over our clothes. I grab four hangers, each with a long satin shirt that’s been studded with sequins. Ellie chooses turquoise, her favorite color. It works well with her olive complexion and dark curls, which she inherited from Carl’s Italian roots. In contrast, Sarah snatches hot pink, a bright anchor to her blond ponytail. Beth and I settle for the leftovers, while Raelynn snags a set for Nate and crew.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-6"
    }
  }, [_vm._v("“Choose a hat.” Beth points to a stand filled with plush velvet caps. We select a few and hurry to the back of the room, where a three-dimensional Mardi Gras mural has been built for photo ops.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-7"
    }
  }, [_vm._v("Sarah waves her hand like a princess and stands straight. “I’m the Queen of Endymion.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-8"
    }
  }, [_vm._v("“And I’m the Queen of Bacchus,” Ellie adds, bending her knees in a dramatic curtsy. I snap her photo, certain it will make the cut for this year’s scrapbook.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-9"
    }
  }, [_vm._v("Just on the other side of the wall, a café keeps our space swirling with scents of chicory coffee, a temptation that is becoming hard to ignore. “Man, I need a cup of brew,” Raelynn admits. She rushes past us with her group of boys, a motley crew of hunters and fishermen who would rather be on a boat or a four-wheeler than anywhere near a city. But they are being good sports, pretending to fight over which one of them gets to wear the pastel pink shirt for the photo.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-10"
    }
  }, [_vm._v("Before the students get too hyper, the guide takes over again. “All righty. Parents, please put the costumes away while I start the film.” He speaks with enthusiasm, dimming the lights.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-5"
    }
  }, [_vm._v("The students quickly pass the gear while black-and-white images begin to flicker, bringing us back to the early 1800s when Creoles held lavish masquerade balls. Eventually the parties spilled into the boulevards, and revelers began to toss special treats to onlookers. Then came the first floats, lit with flambeaus—an elaborate party-on-wheels.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-6"
    }
  }, [_vm._v("“When will they pass out the king cake?” Raeylnn asks, causing the students to look our way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-7"
    }
  }, [_vm._v("Beth puts her finger to her mouth, the way a mother would tell her child to hush. Then she sweeps soft curls from her forehead, revealing a thin streak of gray at her crown. Raelynn’s brightly dyed locks and tattooed wrists mark a stark contrast to Beth’s conservative style. And yet we’ve grown up a tried-but-true trio. The “three amies” as Raelynn likes to call us, a play on her Cajun tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-8"
    }
  }, [_vm._v("The film ends, and we make our way into the café where our guide begins doling out the cake, a braided sweet dough topped with confectioner’s icing and sprinkled with colorful sugar crystals. Miss Henderson prompts, “Do any of you know why we eat king cake?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-9"
    }
  }, [_vm._v("Sarah, teacher’s pet and usually the first to raise her hand, draws a blank and turns to Ellie for backup. But my daughter, too, seems to have no clue. Either that or she’s too shy to answer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-10"
    }
  }, [_vm._v("One of the boys shouts his guess. “Some kind of voodoo thing?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The guide chuckles. “A lot of people do associate New Orleans with voodoo, you’re right. And some in these parts still practice, but we’re mostly a Roman Catholic culture. So if you grew up in Louisiana, you probably already know the story of the three wise men.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-11"
    }
  }, [_vm._v("Seeing we are from Walker, a rural sidekick to Baton Rouge and the kind of place that has more steeples than graves, the guide must realize he’s safe with this religious topic, even if we are a public "), _c('span', {
    attrs: {
      "id": "z17-5"
    }
  }, [_vm._v("school. “Twelve days after Christmas, on January 6, we celebrate the wise men’s visit with the Feast of the Epiphany. And we keep the party going all the way through Fat Tuesday, which in French is called . . . what?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-6"
    }
  }, [_vm._v("“Mardi Gras!” A handful of students are proud to know the answer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-7"
    }
  }, [_vm._v("“That’s right. It’s the day before Ash Wednesday, which of course launches the Lenten season—when Catholics give up our favorite treats and focus on being good.” He laughs before adding, “Well, as good as we can be down here in New Orleans.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-8"
    }
  }, [_vm._v("Then he steers off course a bit. “I’m sure some of you are Catholic.” About half the class raise their hands, including Nate, one of the many CCD kids who has spent his Wednesdays riding the catechism bus to Immaculate Conception. “Anyway, to honor those three wise men, or "), _c('i', [_vm._v("kings")]), _vm._v(", we make the cake round—like a crown—and we only serve it during carnival.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-9"
    }
  }, [_vm._v("Ellie takes a bite, dusting her lips with green sugar sparkles, just as Nate cheers, “I got the baby!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-10"
    }
  }, [_vm._v("“Figures,” Sarah says, eyeing the small plastic token in Nate’s hands. “He wins everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-11"
    }
  }, [_vm._v("When offered a piece of the dessert, Beth holds her perfectly trim waistline, saying, “I’d better not.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-12"
    }
  }, [_vm._v("Raelynn then woos the guide into giving her Beth’s forsaken slice. “Score!” She turns my way, beaming.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-13"
    }
  }, [_vm._v("I nibble my cake and stay with the girls as our guide leads us into the massive warehouse—one of many owned by the business-savvy Kern family. Here, they design and decorate floats, while storing the oversized parade trailers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-14"
    }
  }, [_vm._v("We are led past giant replicas of everything from anime characters to zoo animals. At our first stop, a woman stands on a ladder, "), _c('span', {
    attrs: {
      "id": "z18-5"
    }
  }, [_vm._v("coating a massive sea monster in papier-mâché. Strip by strip, she covers the sculpture with brown craft paper, patiently building a smooth surface for the next round of artists to coat with primer. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-6"
    }
  }, [_vm._v("“They must not know your trick,” Beth says, wafting the air as if she can’t bear the odor. She knows I add cinnamon to our glue at home, where Ellie and I are always working on some kind of art project.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-7"
    }
  }, [_vm._v("“I want this job,” Ellie says, now admiring a half-painted prop. The artist dips a thin brush into a pool of pink and drags it across the lips of a goddess.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-8"
    }
  }, [_vm._v("“Seems like a fun place to work.” I roll my fingers through Ellie’s dark curls. She tolerates my touch for a second before easing away, moving from childhood through tweendom, closing in much too quickly on the tipping point of thirteen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-9"
    }
  }, [_vm._v("“I wish I could draw.” Sarah’s praise causes my daughter’s cheeks to turn pink.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-10"
    }
  }, [_vm._v("“What do you want to be?” I ask Sarah.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-11"
    }
  }, [_vm._v("“A missionary,” she says. “Somewhere far away. Like what my parents did.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-12"
    }
  }, [_vm._v("Beth responds with affection, recalling her brief stint in Ghana where she fell in love with Sarah’s father—the laid-back Cajun youth minister known only as Preacher.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-13"
    }
  }, [_vm._v("Before Beth gets too deep in reminiscing, the guide redirects our attention to another artist, this one drawing a corset around a tiny waistline, exaggerating the voluptuous figure. The painter holds a feather and examines her work.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-14"
    }
  }, [_vm._v("“What do you call that thing she’s wearing?” Sarah asks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-15"
    }
  }, [_vm._v("Beth stiffens. “We’ll talk about that later.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-16"
    }
  }, [_vm._v("Sarah blows her cheeks and accepts defeat, but the artist turns and with a grim expression says, “It’s a corset.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-5"
    }
  }, [_vm._v("I’d guess she’s in her sixties, with thinning gray hair and skin that hasn’t seen the sun in decades. Her clothes, wrinkled and paint-stained, give her a look not so different from the homeless men we saw on our way through the city this morning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-6"
    }
  }, [_vm._v("“What’s the feather for?” Our guide points to the brilliant blue plume in the painter’s hand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-7"
    }
  }, [_vm._v("After a heavy sigh, the woman grimaces. “Well, a long time ago, women used to wear these corsets under their fancy dresses. Some people called them "), _c('i', [_vm._v("stays")]), _vm._v(". Girls had to start wearing them when they were very young. Maybe eight years old.” She looks at Ellie. “How old are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-8"
    }
  }, [_vm._v("“Twelve,” Ellie answers, nibbling her fingernail. It’s a habit she’s trying to break.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-9"
    }
  }, [_vm._v("“Twelve,” the woman confirms. “So, if you lived in the eighteenth or nineteenth century, you’d be wearing one of these. Your ribs and your lungs and your stomach would all be pinched up tight beneath the stays.” She tweaks her face at the thought of it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-10"
    }
  }, [_vm._v("“Why?” Sarah asks. Not a speck of hesitation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-11"
    }
  }, [_vm._v("“That’s the question.” The artist smirks. “Why do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-12"
    }
  }, [_vm._v("No one comes up with a guess.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-13"
    }
  }, [_vm._v("“Because women were slaves.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-14"
    }
  }, [_vm._v("Beth scoffs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-15"
    }
  }, [_vm._v("“It’s true!” The artist comes closer. “Slaves to fashion. To society. To culture. The men wanted women to have tiny waists, and we gave them what they wanted.” She points her feather at our tour guide, the only adult male in the group. “Sometimes, if a man was looking for a wife, he would line up women and wrap his hands around their waists. If his fingers could touch, she might stand a chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-16"
    }
  }, [_vm._v("The girls begin to wrap their midlines, measuring their own worth according to waist size.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-5"
    }
  }, [_vm._v("The artist notices. “Women were expected to wear these corsets all the time, so they could train their bodies to have this wasp shape.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-6"
    }
  }, [_vm._v("“Why?” Sarah asks again, leaning in for a closer look.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-7"
    }
  }, [_vm._v("“Because most women couldn’t work, remember? They needed someone to provide for them. Many even slept in these corsets, tightening the straps more and more each day. Some schools would measure their female students, making sure waistlines were shrinking. Like those foot-binding traditions in China. Ever hear of that?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-8"
    }
  }, [_vm._v("Ellie looks back at me, her eyes wide with curiosity. “Later,” I whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-9"
    }
  }, [_vm._v("“The things we do to our girls. Torture, I tell you.” The painter shakes her head. “Good thing I wasn’t alive back then. Put me into one of those things? Might as well wear a straitjacket.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-10"
    }
  }, [_vm._v("Beth whispers between her teeth, “I’m thinking she could use a little time in a corset.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-11"
    }
  }, [_vm._v("It’s the meanest thing I’ve ever heard Beth say. I raise one finger, just enough to catch the artist’s attention. “I’m still not clear. What’s the feather for?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-12"
    }
  }, [_vm._v("“Oh yes. I got sidetracked. Sorry.” Her eyes light up. “For years, the corset boning was made out of hard, rigid materials. Rods. Reeds. Whalebones. Can you imagine? Being caged into that every day? Even at night?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-13"
    }
  }, [_vm._v("Girls peak their brows. Boys shake their heads. Parents sigh.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-14"
    }
  }, [_vm._v("“But in the late 1800s a man named Edward K. Warren had a store up in Michigan. Dry goods, they called it back then. His customers complained about the whalebone corsets. They were too expensive, too uncomfortable. They didn’t seem to hold up. So when Mr. Warren was buying supplies over in Chicago, he noticed a factory that made feather dusters—you know those old-fashioned "), _c('span', {
    attrs: {
      "id": "z21-5"
    }
  }, [_vm._v("dusters?” She waves her feather as if dusting the corset. “Y’all ever seen those?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz21-6"
    }
  }, [_vm._v("Miss Henderson promises she’ll bring one to class next week.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz21-7"
    }
  }, [_vm._v("“Well, anyway, Mr. Warren noticed that the factory threw away big piles of feathers. He thought he might be able to use them to make corsets. And he was right. He patented his idea. Earned himself a fortune. People loved his new featherbone corsets. You know why?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz21-8"
    }
  }, [_vm._v("Blank stares.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz21-9"
    }
  }, [_vm._v("So she continues. “They were less expensive, for one thing, but mainly the featherbones allowed women to bend.” She bows the feather, demonstrating her claim. “So in a way, Mr. Warren helped women break free from bondage. You see? This was the beginning of their—emancipation—so to speak.” She stresses this word. “Anybody know what that means?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz21-10"
    }
  }, [_vm._v("Nate pipes up from the back. “Set them free?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz21-11"
    }
  }, [_vm._v("“Exactly!” The artist’s face softens, and a warm smile stretches her mouth. “So when I got this assignment to examine women’s fashion, I decided to give these nineteenth-century women some breathing room. Kind of my own little act of rebellion.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz21-12"
    }
  }, [_vm._v("She looks at the group of children with a tenderness now, then toward the ceiling where birds flitter between the roof beams, serenading us. “Girls, promise me this. Every time you see a bird flying around with her beautiful feathers, I want you to think of all the women who strapped themselves into corsets against their wishes. Think of all the women who fought to break free from those restraints. And then remind yourselves to never again become slaves. In any way, to anyone. You keep yourselves free. Understand?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz21-13"
    }
  }, [_vm._v("The girls whisper as we leave the woman. “Who would want to look like a wasp anyway?” Ellie asks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz22-1"
    }
  }, [_vm._v("“I’m glad we don’t have to live like that. In a cage!” Sarah says. She squirms as she reaches behind her back. “Now if only we could stop wearing these.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz22-2"
    }
  }, [_vm._v("They both giggle, and Beth pulls her lips tight, still recovering from our recent shopping trip when we bought the girls their first real bras.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz22-3"
    }
  }, [_vm._v("I put my arm around Beth’s shoulders. “If only we could slow the world for them,” I say. “Keep them young, and safe. And free.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b975c9b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter01.vue
// module id = 78
// module chunks = 0